import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../core/hooks/useAuth';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    const location = useLocation();

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner">Загрузка...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Перенаправляем на страницу входа, сохраняя текущий путь
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
}; 